import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useLearnDeckNavigatorOptions } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.navigator";
import { useCallback } from "react";
function useNavigator() {
  const options = useLearnDeckNavigatorOptions();
  return useCallback(
    ({ slideSlug }: { slideSlug: string }) => options({ kind: "slide", slideSlug }),
    [options],
  );
}
export const useSlideLessonPageNavigator = createPageNavigator({ useNavigator });
